import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api, authImageUrl } from "@/lib/api";
import { ArrowLeft, ChevronRight, Building2, Users, Crown } from "lucide-react";

const Avatar = ({ m, size = "w-10 h-10" }) => {
  if (!m) return null;
  return m.photo_url ? (
    <img src={authImageUrl(m.photo_url)} alt={m.cognome}
      className={`${size} rounded-md object-cover border border-gold/40 shrink-0`}
      onError={(e) => { e.target.style.display = "none"; }} />
  ) : (
    <div className={`${size} rounded-md bg-navy flex items-center justify-center border border-gold/40 shrink-0`}>
      <span className="font-display text-gold font-bold text-sm">
        {(m.nome?.[0] || "").toUpperCase()}{(m.cognome?.[0] || "").toUpperCase()}
      </span>
    </div>
  );
};

export default function DivisionClubs() {
  const { division } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const decoded = decodeURIComponent(division);

  useEffect(() => {
    api.get(`/org/divisions/${encodeURIComponent(decoded)}/clubs`).then((r) => setData(r.data));
  }, [decoded]);

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="division-detail">
      <Link to="/distretto" className="inline-flex items-center gap-2 text-sm font-semibold text-navy hover:text-navy-hover transition-colors" data-testid="back-to-distretto">
        <ArrowLeft className="w-4 h-4" /> Torna al Distretto
      </Link>

      <div>
        <p className="text-xs tracking-[0.15em] uppercase font-bold text-gold">Divisione</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-navy mt-1 tracking-tight">{decoded}</h1>
        {data && <p className="text-sm text-muted-foreground mt-1">{data.clubs.length} club in questa divisione</p>}
      </div>

      {!data ? (
        <div className="text-center py-16 text-navy">Caricamento…</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {data.clubs.map((c) => (
            <button key={c.club} onClick={() => navigate(`/club/${encodeURIComponent(c.club)}`)} data-testid={`club-card-${c.club}`}
              className="group text-left bg-white rounded-lg border border-navy/10 p-5 hover:shadow-md hover:-translate-y-1 transition-transform transition-shadow duration-200">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2 min-w-0">
                  <Building2 className="w-5 h-5 text-navy shrink-0" />
                  <h3 className="font-display text-lg font-semibold text-navy leading-snug truncate">{c.club}</h3>
                </div>
                <ChevronRight className="w-5 h-5 text-gold shrink-0 group-hover:translate-x-1 transition-transform duration-200" />
              </div>
              <div className="mt-3 flex items-center gap-3 border-t border-navy/5 pt-3">
                {c.president ? (
                  <>
                    <Avatar m={c.president} />
                    <div className="min-w-0">
                      <p className="text-[10px] uppercase tracking-wider text-gold font-bold flex items-center gap-1"><Crown className="w-3 h-3" />Presidente</p>
                      <p className="text-sm font-semibold text-navy-deep truncate">{c.president.nome} {c.president.cognome}</p>
                    </div>
                  </>
                ) : (
                  <p className="text-xs text-muted-foreground italic">Presidente non indicato</p>
                )}
              </div>
              <p className="mt-3 text-xs text-muted-foreground flex items-center gap-1"><Users className="w-3.5 h-3.5" />{c.members_count} soci · vedi elenco</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
